import { faBars, faClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { useAccountContext, useAppContext } from '../contexts'
import { isPhone } from '../common/constants'

interface Props {
  links: { [key: string]: string }
}

export function SideNav({ links }: Props) {
  const { showSidebarNav, setShowSidebarNav } = useAppContext()
  const { selectDevice } = useAccountContext()

  return (
    <div>
      <div>
        <FontAwesomeIcon
          className={showSidebarNav ? tailwind.closeButton : tailwind.hamburgerMenu}
          icon={showSidebarNav ? faClose : faBars}
          onClick={() => setShowSidebarNav(!showSidebarNav)}
          size="lg"
        />
      </div>
      <div className={tailwind.sidePanel + `${showSidebarNav ? ' translate-x-0' : ' translate-x-full'}`}>
        <div className={tailwind.linksContainer}>
          {Object.keys(links).map((key, index) => (
            <Link
              key={index}
              to={links[key]}
              onClick={() => {
                selectDevice('')
                setShowSidebarNav(false)
              }}
              replace
              className={tailwind.link}
            >
              {key}
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}

const tailwind = {
  sidePanel: 'top-0 right-0 w-[200px] bg-[#ddd] px-2 py-0 fixed h-full z-40 ease-in-out duration-300',
  linksContainer: 'flex flex-col justify-center',
  link: `text-lg mt-4 lg:inline-block lg:mt-0 ml-5 mr-5 text-blue-500 hover:text-blue-800 no-underline`,
  hamburgerMenu: `fixed z-30 flex items-center cursor-pointer bg-white ${
    isPhone ? 'p-2.5 right-0 top-0' : 'p-3 right-0 top-0'
  }`,
  closeButton: 'flex text-2xl text-black items-center cursor-pointer fixed right-3 top-3 z-50',

  // navigation: 'flex justify-between bg-white p-1',
  // logo: 'flex items-center flex-shrink-0 text-white mr-6',
  // // linkContainer: 'justify-right', // 'w-full block flex-grow justify-right lg:flex lg:items-center lg:w-auto',
  // linkContainer: 'text-sm lg:flex-grow',
}
